export function roleReducer(state = [], action) {
	switch (action.type) {
		case "role":
			return action.payload;
		default:
			return state;
	}
}
